import "./styles.scss";

import moment from "moment";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

import SelectablePill from "components/SelectablePill";
import TrackerButton from "components/TrackerButton";
import Calendar from "components/Calendar";

const mainClass = "data-tile";

const DataTile = ({
  label,
  status,
  priority,
  time_tracker,
  created_at,
  due_date,
  website,
  isTaskOnboarding,
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={classnames(mainClass, {
        website_created: isTaskOnboarding,
      })}
    >
      <h4>{label}</h4>
      <div className={`${mainClass}__rows`}>
        {!!status && (
          <div>
            <p>{t("Status")}</p>
            <SelectablePill {...status} />
          </div>
        )}
        {!!priority && (
          <div>
            <p>{t("Priority")}</p>
            <SelectablePill {...priority} />
          </div>
        )}
        <div>
          <p>{t("Work time")}</p>
          <div>
            {time_tracker?.readOnly ? (
              <span>{time_tracker.readOnly}</span>
            ) : time_tracker ? (
              <TrackerButton
                active={time_tracker?.active}
                time={time_tracker?.label}
                disable_tracking={time_tracker?.disable_tracking}
                start_time_tracked={time_tracker?.start_time_tracked}
                onClick={time_tracker?.onclick}
              />
            ) : (
              "-"
            )}
          </div>
        </div>
        {!!due_date && (
          <div>
            <p>{t("Due date [ALT]")}</p>
            <div className={`${mainClass}__due-date`}>
              <span>
                {due_date?.value
                  ? moment(due_date.value).format("LL")
                  : t("Select date")}
              </span>
              {!due_date?.isCompletelyDisabled && (
                <Calendar
                  only_icon
                  close_icon
                  default_value={due_date?.value}
                  onChange={due_date?.onChange}
                />
              )}
            </div>
          </div>
        )}
      </div>
      <div className={`${mainClass}__footer`}>
        <p>
          {t("Created")}: {created_at ? moment(created_at).format("LL") : "-"}
          {website?.name && (
            <>
              {" "}
              {t("for")}{" "}
              <button type="button" onClick={website?.onClick}>
                {website.name}
              </button>
            </>
          )}
        </p>
      </div>
      {onClick && (
        <div className={`${mainClass}__cta`}>
          <button type="button" onClick={onClick}>
            {t("View details")}
          </button>
        </div>
      )}
    </div>
  );
};

export default DataTile;
